import React from 'react';
import {AccountInfo} from '../../reducers/user.reducer';
import EpicGamesFooter from 'epic-games-footer/app/scripts/EpicGamesFooter';

//@ts-ignore
import styles from './Footer.pcss';

interface FooterProps {
    content: any;
    accountInfo: AccountInfo;
}

const Footer: React.FC<FooterProps> = ({content, accountInfo}) => {
    const {links = []} = content || {};

    return (
        <div className={styles.footer}>
            <EpicGamesFooter
                epicPropertyName="epic_games"
                links={links}
                isLoggedIn={true}
                wrapperId="affiliateWrapper"
                email={accountInfo.email || ''}
                {...content}
            />
        </div>
    );
};

export default Footer;
